export const IntegrationStatuses = {
	Active: 'Active',
	Incomplete: 'Incomplete',
	Unauthorised: 'Unauthorised',
} as const;
export type IntegrationStatus =
	(typeof IntegrationStatuses)[keyof typeof IntegrationStatuses];
